import axios from 'axios'
import type {
  CompanyFilePaginatedRequest,
  CompanyFilePaginatedResponse,
} from 'types'

export const companyFileList = (
  companyUuid: string,
  request: CompanyFilePaginatedRequest,
) =>
  axios
    .get<CompanyFilePaginatedResponse>(`/api/companies/${companyUuid}/files`, {
      params: request,
    })
    .then((res) => res.data)

interface CompanyFileDeleteProps {
  companyUuid: string
  fileUuid: string
}

export const companyFileDelete = ({
  companyUuid,
  fileUuid,
}: CompanyFileDeleteProps) =>
  axios
    .delete<void>(`/api/companies/${companyUuid}/files/${fileUuid}`)
    .then((res) => res.data)
